import { render, staticRenderFns } from "./commonSettings.vue?vue&type=template&id=642064e9&scoped=true"
import script from "./commonSettings.vue?vue&type=script&lang=js"
export * from "./commonSettings.vue?vue&type=script&lang=js"
import style0 from "./commonSettings.vue?vue&type=style&index=0&id=642064e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642064e9",
  null
  
)

export default component.exports